import React from "react";
import { Skeleton } from 'primereact/skeleton';
import PurchaseOrderItemSkeleton from "./PurchaseOrderItem";


const PurchaseOrderDesktopSkeleton = () => {
    return(
        <div className="flex flex-column px-3 py-2">
            <div className="flex mb-2 justify-content-between gap-2">
                <Skeleton className="flex align-self-start mb-3" width="11rem"></Skeleton>
                <div className="flex align-items-center mb-2">
                    <Skeleton width="26rem" height="2.5rem"></Skeleton>
                </div>
                <div className="col-2"></div>
            </div>
            <div style={{ padding: "20px 10%"}}>
                <PurchaseOrderItemSkeleton className="mb-3" />
                <PurchaseOrderItemSkeleton className="mb-3" />
                <PurchaseOrderItemSkeleton className="mb-3" />
                <PurchaseOrderItemSkeleton className="mb-3" />
                <PurchaseOrderItemSkeleton className="mb-3" />
                <PurchaseOrderItemSkeleton className="mb-3" />
                <PurchaseOrderItemSkeleton className="mb-3" />
            </div>
        </div>
    )
}

export default PurchaseOrderDesktopSkeleton;